<script setup lang="ts">
    import { __ } from '@/js/stores/expressions';
    import { ref, onMounted } from 'vue';
    import SvgIcon from '../SvgIcon.vue';
    import { useFilterStoreByName } from '@/js/stores/filter';
    import { FilterStoreName } from '@/js/services/api/filter/types';
    import EchoButton from '../EchoButton.vue';
    import { XIcon } from '@lucide/vue';

    const slotRef = ref<HTMLElement | null>(null);
    const filterLabel = ref('');
    const filterStore = useFilterStoreByName(FilterStoreName.SharedFilter);

    const props = withDefaults(
        defineProps<{
            filterName?: string;
            icon?: string;
            removable?: boolean;
            color?: 'gray' | 'white' | 'black';
        }>(),
        {
            filterName: '',
            icon: '',
            removable: true,
            color: 'gray',
        }
    );

    onMounted(() => {
        if (props.filterName) {
            filterLabel.value = props.filterName;
        } else if (slotRef.value) {
            filterLabel.value = slotRef.value.innerText;
        }
    });
    const removeFilter = () => {
        emit('remove-filter');
        filterStore.clearSelectedFavoriteFilter();
    };
    const emit = defineEmits<{
        (e: 'remove-filter'): void;
    }>();
</script>

<template>
    <EchoButton
        variant="chip"
        :aria-label="__('remove-active-filter', { filter: filterLabel })"
        :disabled="!removable"
        @click="removeFilter"
    >
        <span ref="slotRef" class="pointer-events-none">
            <span v-if="props.icon" class="block pl-7">
                <span class="block p-0.25 absolute left-3.25 top-0.75 rounded-full">
                    <SvgIcon
                        :name="icon"
                        size="size-5"
                        class="fill-transparent stroke-transparent"
                    />
                </span>
                <slot />
            </span>
            <template v-else><slot /></template>
        </span>
        <template v-if="removable" #icon-right>
            <span class="flex size-full items-center justify-center">
                <XIcon class="size-3.25 text-gray-medium" />
            </span>
        </template>
    </EchoButton>
</template>
